import React from "react";

import projects from "../../static/information/projects";

import ProjectItem from "./ProjectItem";

const ProjectsList = () => {
  return (
    <div>
      {projects.map((project) => (
        <ProjectItem key={project.id} project={project} />
      ))}
    </div>
  );
};

export default ProjectsList;
